<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(:filter.sync="nameFilter")
    filter-suppliers.mr-2(:filter.sync="suppliersFilter")
    filter-reference.mr-2(:filter.sync="referenceFilter")
    filter-order-statuses.mr-2(:filter.sync="orderStatusFilter")
    filter-payment-statuses.mr-2(:filter.sync="paymentStatusFilter")
    filter-date.mr-2(:filter.sync="dueDateFilter" title="Due date" param="due_date")
    filter-date.mr-2(:filter.sync="issueDateFilter" title="Date issued" param="record_date")
    filter-amount.mr-2(:filter.sync="amountFilter" title="Amount" param="amount")
    filter-amount.mr-2(:filter.sync="balanceFilter" title="Unpaid balance" param="balance")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterSuppliers from '@/components/clinic/purchasehub/filters/FilterSuppliers.vue'
import FilterReference from '@/components/clinic/purchasehub/filters/FilterReference.vue'
import FilterOrderStatuses from '@/components/clinic/purchasehub/filters/FilterOrderStatuses.vue'
import FilterInventoryStatuses from '@/components/clinic/purchasehub/filters/FilterInventoryStatuses.vue'
import FilterPaymentStatuses from '@/components/clinic/purchasehub/filters/FilterPaymentStatuses.vue'
import FilterDate from '@/components/module/filter/FilterDate.vue'
import FilterAmount from '@/components/module/filter/FilterAmount.vue'

export default {
  components: { 
    FilterName, FilterSuppliers, FilterReference, FilterOrderStatuses, FilterInventoryStatuses, FilterPaymentStatuses, FilterDate, FilterAmount
  },
  props: ['filters'],
  data: () => ({
    key: 0,
    nameFilter: {},
    suppliersFilter: {},
    referenceFilter: {},
    orderStatusFilter: {},
    inventoryStatusFilter: {},
    paymentStatusFilter: {},
    dueDateFilter: {},
    issueDateFilter: {},
    amountFilter: {},
    balanceFilter: {},
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.suppliersFilter.key) {
        filters.push(this.suppliersFilter)
      }
      if (this.referenceFilter.key) {
        filters.push(this.referenceFilter)
      }
      if (this.orderStatusFilter.key) {
        filters.push(this.orderStatusFilter)
      }
      if (this.inventoryStatusFilter.key) {
        filters.push(this.inventoryStatusFilter)
      }
      if (this.paymentStatusFilter.key) {
        filters.push(this.paymentStatusFilter)
      }
      if (this.dueDateFilter.key) {
        if (this.dueDateFilter.key === 'between') {
          const values = this.dueDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.dueDateFilter)
        }
      }
      if (this.issueDateFilter.key) {
        if (this.issueDateFilter.key === 'between') {
          const values = this.issueDateFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.issueDateFilter)
        }
      }
      if (this.amountFilter.key) {
        if (this.amountFilter.key === 'between') {
          const values = this.amountFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.amountFilter)
        }
      }
      if (this.balanceFilter.key) {
        if (this.balanceFilter.key === 'between') {
          const values = this.balanceFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.balanceFilter)
        }
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.nameFilter = {}
      this.suppliersFilter = {}
      this.referenceFilter = {}
      this.orderStatusFilter = {}
      this.inventoryStatusFilter = {}
      this.paymentStatusFilter = {}
      this.dueDateFilter = {}
      this.issueDateFilter = {}
      this.amountFilter = {}
      this.balanceFilter = {}
    },
  }
}
</script>